export default {"src":"/_next/static/media/digital.9006f9b8.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};